import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import AzureMigrationPerformanceTab from './AzureMigrationPerformanceTab';
import AzureMigrationWeeklyCohortTab from './AzureMigrationWeeklyCohortTab';

/**
 * Wrapper that groups "Single instance" and "Weekly cohort" performance reports
 * under a single top-level tab using inner sub-tabs.
 */
const AzureMigrationPerformanceView = () => {
  const [subTab, setSubTab] = useState(0);

  return (
    <Box>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          mb: 3
        }}
      >
        <Tabs
          value={subTab}
          onChange={(_, v) => setSubTab(v)}
          textColor="primary"
          indicatorColor="primary"
          sx={{
            minHeight: 40,
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 500,
              fontSize: '0.875rem',
              minHeight: 40,
              py: 1
            }
          }}
        >
          <Tab label="Single instance" />
          <Tab label="Weekly cohort" />
        </Tabs>
      </Box>

      {subTab === 0 && <AzureMigrationPerformanceTab />}
      {subTab === 1 && <AzureMigrationWeeklyCohortTab />}
    </Box>
  );
};

export default AzureMigrationPerformanceView;
